import { useEffect, useState } from "react";
import { toast } from "sonner";
import { MapPin } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { useApi, errMsg } from "@/lib/api";

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");

export const TrackPicker = () => {
  const api = useApi();
  const [tracks, setTracks] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api("get", "/admin/tracks").then(setTracks).catch(() => {}); }, [api]);
  if (!tracks) return null;

  const toggle = async (name, on) => {
    const off = tracks.filter((t) => (t.name === name ? !on : !t.on)).map((t) => t.name);
    setBusy(true);
    try { setTracks(await api("put", "/admin/tracks", { off })); toast.success(`${name} ${on ? "added to" : "removed from"} the automatic import`); }
    catch (e) { toast.error(errMsg(e)); }
    finally { setBusy(false); }
  };
  const states = [...new Set(tracks.map((t) => t.state))];

  return (
    <section className="rounded-2xl bg-[#131C31] border border-white/5 p-5 space-y-3" data-testid="admin-track-picker">
      <h2 className="font-display text-lg font-bold flex items-center gap-2"><MapPin className="w-4 h-4 text-blue-400" />Tracks in the automatic import</h2>
      <p className="text-xs text-slate-500">Switched-off tracks are skipped by the 5am and early-Saturday imports. You can still import any meeting yourself in the Import panel.</p>
      <div className="grid grid-cols-2 gap-x-6 gap-y-3">
        {states.map((s) => (
          <div key={s}>
            <p className="text-[11px] font-semibold text-slate-500 mb-1">{s}</p>
            {tracks.filter((t) => t.state === s).map((t) => (
              <label key={t.name} className="flex items-center justify-between gap-3 py-1 text-sm cursor-pointer">
                <span className={t.on ? "" : "text-slate-500"}>{t.name}</span>
                <Switch checked={t.on} disabled={busy} onCheckedChange={(v) => toggle(t.name, v)} data-testid={`track-toggle-${slug(t.name)}`} />
              </label>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};
